import React from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/lib/Async';
import { isEmpty } from '../../utils/utils';

class NowSelect extends React.Component {
  static defaultProps = {
    className: '',
    isAsync: false,
    isLongList: false,
  };

  render() {
    const {
      className,
      isAsync,
      isLongList,
      value,
      options,
      onChange,
      loadOptions,
      isClearable = true,
      onClick,
      required = false,
      width = '100%',
      disabled = false,
      theme=(provide) => ({
        ...provide,
        borderRadius: 0,
        colors: {
          ...provide.colors,
          primary: '#EE4D2D',
        },
      }),
      ...rest
    } = this.props;
    const requiredClass =
      required && (isEmpty(value) || value.value <= 0) ? ' form-required' : '';
    const disabledClass = disabled ? 'element-disabled' : '';
    const commonProps = {
      className: `${className} ${requiredClass} ${disabledClass}`,
      classNamePrefix: 'now-select',
      isClearable,
      isSearchable: true,
      value,
      onChange,
      menuPlacement: 'auto',
      theme,
      ...rest,
    };

    return !isAsync ? (
      <div onClick={onClick} style={{ width }}>
        <Select options={options} {...commonProps} />
      </div>
    ) : (
      <div onClick={onClick} style={{ width }}>
        <AsyncSelect loadOptions={loadOptions} {...commonProps} />
      </div>
    );
  }
}

export default NowSelect;



// WEBPACK FOOTER //
// ./foody/src/components/Common/NowSelect.jsx